import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const courseEnrollmentImporterSelectors = importerSelectors(
  'courseEnrollment.importer',
)

export default courseEnrollmentImporterSelectors
